<template>
  <section class="is-fluid columns is-fullheight is-flex local-lm-global-dashboard">
    <div class="column is-1 local-lm-left-menu">
      <left-menu />
    </div>
    <div class="column is-11 local-lm-main">
      <top-menu />
      <div class="section">
        <router-view></router-view>
      </div>
    </div>
  </section>
</template>

<script>
import TopMenu from '@/components/dashboard/TopMenu'
import LeftMenu from '@/components/dashboard/LeftMenu'

export default {
  name: 'DashboardUser',
  data () {
    return {
    }
  },
  components: {
    TopMenu,
    LeftMenu
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue